import { createContainer } from "unstated-next";
import request from "project-config/services/request/request";
import { useEffect, useState } from "react";
import { IAccessInfo } from "../types";

export function useDeveloperStoreHook() {
  const [access, setAccess] = useState<IAccessInfo | null>();
  const [hasAccess, setHasAccess] = useState(true);
  const [loading, setLoading] = useState(true);

  const fetchAccessInfo = async () => {
    setLoading(true);
    const res = await request.post(
      "/api/rendering/user/developer/queryAccessId"
    );
    if (res && res.code === 200) {
      setAccess(res.data);
    } else if (res.code === 942) {
      setHasAccess(false);
      setAccess(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAccessInfo();
  }, []);

  return {
    access,
    setAccess,
    hasAccess,
    loading,
    fetchAccessInfo,
  };
}

const DeveloperStoreContainer = createContainer(useDeveloperStoreHook);

export const DeveloperStoreProvider = DeveloperStoreContainer.Provider;

export function useDeveloperStore() {
  return DeveloperStoreContainer.useContainer();
}
